export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Tidsgränsen för beställningen har löpt ut",
      "649f8aefc1c0": "Återvinningen misslyckades",
      "649f8aefc9c0": "Få en ny värdering",
      "TradeIn": "Inbytesprocess",
      "logistic": "Ladda ner fraktetikett",
      "start": "Starta processen",
      "success": "Du har framgångsrikt tagit emot den nya enheten",
      "qc": "Kvalitetskontroll av den gamla enheten",
      "business": "Inspektionen av din gamla enhet kommer att vara klar inom tre arbetsdagar",
      "completed": "Slutförd",
      "successfully": "Grattis! Inbytet har slutförts framgångsrikt",
      "orderInfor": "Beställningsinformation",
      "orderID": "Inbytesorder-ID",
      "orderNum": "Nytt enhetsköps-ID",
      "createTime": "Skapelsedatum",
      "brand": "Uppskattat märke",
      "model": "Uppskattad modell",
      "price": "Pris för den gamla enheten",
      "bonus": "Bonus",
      "reclaimFailure": "Eftersom du inte skickade enheten inom 10 dagar efter mottagandet har återvinningsordern löpt ut och annullerats. Om du fortfarande vill genomföra återvinningen kan du klicka på knappen nedan för att kontrollera den senaste värderingen.",
      "total": "Totalt pris",
      "logisticInfo": "Logistikinformation",
      "available": "Ingen logistikinformation tillgänglig",
      "logisticNum": "Logistiknummer",
      "failRey": "Vi beklagar att ditt deltagande i OnePlus återvinningsprogram inte slutfördes framgångsrikt. Om du har planer på att återvinna andra elektroniska produkter kan du klicka på knappen nedan för att få en snabb uppskattning!",
      "userRes": "Användaren har redan avvisat erbjudandet.",
      "successPrice": "Följande pris är fastställt efter professionell inspektion. Om du godkänner detta pris kan du fortsätta med inbytet. Om du avvisar det kommer enheten att skickas tillbaka till dig inom några arbetsdagar.",
      "sure": "Acceptera",
      "Reject": "Avvisa",
      "congratulation": "Grattis! Kvalitetskontrollen visade inga skillnader.",
      "finPirce": "Slutpris",
      "copySuccess": "Kopieringen lyckades",
      "copyfail": "Kopieringen misslyckades",
      "sureSuccess": "Bekräfta lyckad transaktion",
      "submitError": "Inlämningen misslyckades",
      "detectionResult": "Inspektionsresultat",
      "Collected": "Lägg en beställning",
      "inTransit": "Under transport",
      "656g0lj3sav6": "Återvinningsprocess",
      "656g0lj3cd5a": "Fyll i dina personuppgifter korrekt och slutför beställningen framgångsrikt",
      "656g0lj3dr9a": "Inspektionen av din telefon kommer att slutföras inom 48 timmar efter att den har anlänt till vårt center",
      "656g0lj3epal": "När inspektionen är klar kommer vi att kontakta dig via e-post med det slutliga erbjudandet",
      "656g0lj3pda2": "Din uppskattning",
      "656g0lj3ed3d": "Professionell kvalitetskontroll",
      "656g0lj3esf3": "Kopiera",
      "expertDiscount": "Kampanjkod",
      "invalidCode": "Ogiltig kod",
      "toastTip": "Jag godkänner sekretesspolicyn och villkoren",
      "649f8aef26sf": "Inbytesprocess",
      "checkTitle": "Testinformation",
      "basicInformation": "Grundläggande information",
      "understand": "Jag förstår"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Vägra återvinning",
      "64a9shqq3k00": "Du bekräftar att du vägrar återvinning",
      "64a9shqq3r00": "Avbokning lyckades",
      "64a9shqq3ws0": "Avbokning misslyckades",
      "sureCancel": "Bekräfta avbokning"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Vilka",
      "646u995lv9g0": "är vi?",
      "646u9d5lv9g0": "Danghuan är ett företag med fokus på återvinning, bearbetning och försäljning av 3C-produkter som mobiler, surfplattor, bärbara datorer och klockor. Vårt mål är att öka effektiviteten i elektronisk återvinning och främja en hållbar utveckling av andrahandsmarknaden. Företaget har officiella strategiska partnerskap med OPPO, Vivo, OnePlus, Realme och andra. Vi har verksamhet i Indien, Thailand, Vietnam, Kambodja och nu även i Europa.",
      "646u995dv9g0": "Vår globala närvaro har gjort oss till en strategisk partner för mobiloperatörer, tillverkare och grossister, både lokalt och internationellt.",
      "646u99slv9g0": "Vi samarbetar med ledande tillverkare och upprätthåller ett brett lager av produkter i olika prisklasser för att kunna erbjuda skräddarsydda lösningar och konkurrenskraftiga priser till våra kunder."
    },
    "business": {
      "646v04syvpk0": "Är du intresserad av att köpa från vårt lager?",
      "646v04syxs80": "Hos Danghuan erbjuder vi ett omfattande urval av mobiltelefoner, surfplattor och smartklockor i olika kvalitetsnivåer för att möta olika affärsbehov.",
      "646v04syy6g0": "Kontakta vår försäljnings- och inköpschef:",
      "646v04syya80": "Jag vill köpa",
      "646v04syydg0": "Ange ditt namn",
      "646v04syyh40": "Ange ditt telefonnummer",
      "646v04syyyw0": "Ange din e-postadress",
      "646v0gsyz1s0": "Land:",
      "646v04syz1s0": "Välj ett alternativ",
      "646v04syz4o0": "Jag har läst och accepterar",
      "646v04syzkc0": "sekretesspolicyn",
      "646v04syzok0": "Kontakta oss",
      "646v04syzvo0": "Ange ditt telefonnummer",
      "646v04syzys0": "Ange din e-postadress",
      "646v04sz01o0": "Ange en giltig e-postadress",
      "646v04sz04g0": "Ange ditt namn",
      "646v04sz0740": "Markera rutan för att godkänna sekretesspolicyn",
      "646v04sz0a00": "Inlämningen lyckades",
      "646v04sz0cw0": "Inlämningen misslyckades",
      "title1": "Transparent enhetsklassificering",
      "text1-1": "För att hjälpa dig med ditt köpbeslut rekommenderar vi att du granskar vårt detaljerade klassificeringsdokument. Det beskriver de estetiska och funktionella standarderna för varje kategori, vilket hjälper dig att fatta välinformerade beslut som matchar dina förväntningar.",
      "title2": "Exceptionell kundsupport",
      "text2-1": "Vi förstår varje kunds unika behov, därför erbjuder vårt flerspråkiga säljteam personlig och professionell service.",
      "title3": "Engagemang för hållbar teknik",
      "text3-1": "Vi är engagerade i att främja global tillgång till hållbar teknik och säkerställa att våra processer skapar värde för alla intressenter.",
      "text3-2": "För ytterligare frågor eller för att göra en testbeställning, vänligen kontakta oss. Vårt team står redo att hjälpa dig med professionalism och omsorg."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Få betalt snabbt i bara fyra steg",
      "s1": "Första steget",
      "s1t": "Packa din enhet så att den anländer i samma skick som den skickades.",
      "s2": "Andra steget",
      "s2t": "Lämna in ditt paket på närmaste inlämningsställe.",
      "s3": "Tredje steget",
      "s3t": "Vi kontrollerar din enhet och ger dig en offert.",
      "s4": "Fjärde steget",
      "s4t": "Få din betalning snabbt."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Håll dig uppdaterad",
      "section3-text2": "Surfplattor",
      "section3-text4": "Klockor",
      "section3-text5": "Övrigt",
      "title": "Snabb värdering",
      "t1": "Välj typ och starta värdering, få en rättvis offert.",
      "t2": "Enkla steg – njut av vår snabba återvinningstjänst!"
    },
    "section6": {
      "646txzpazuc0": "Om Danghuan",
      "666txzpazuc0": "Ett företag som specialiserar sig på återvinning och återanvändning av smartphones, surfplattor och andra digitala enheter, och som erbjuder en enkel, säker och effektiv tjänsteprocess så att varje kund enkelt kan återvinna sin använda enhet.",
      "646txzpb0rk0": "Detaljer",
      "646txzpb0xc0": "Vi erbjuder återvinningstjänster för 12 varumärken"
    },
    "section7": {
      "646ns2k5f7k0": "Vår tjänst är alltid tillgänglig",
      "646ns2k5gmw0": "Kundtjänst: måndag till fredag kl. 9.00–18.00 CET (UTC+1:00) Madrid, Spanien",
      "646ns2k5gs40": "Ange ditt namn",
      "646ns2k5gx40": "Ange ditt telefonnummer",
      "646ns2k5img0": "Ange din e-postadress",
      "646ns2k5isw0": "Skriv ett meddelande till oss innan vi kontaktar dig",
      "646ns2k5iws0": "Kontakta oss",
      "646ns2k5j140": "Ange ditt telefonnummer",
      "646ns2k5j4g0": "Ange din e-postadress",
      "646ds2k5j4g0": "E-post",
      "646ns2k5j6c0": "Ange en giltig e-postadress",
      "646ns2k5j8g0": "Kontakta oss",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Adress",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Spanien",
      "646ns2k5jgc0": "Ange ditt namn",
      "646ns2k5ji40": "Markera rutan för att godkänna sekretesspolicyn",
      "646ns2k5jk00": "Inlämningen lyckades",
      "646ns2k5jm80": "Inlämningen misslyckades",
      "646ny1rgz3c0": "Jag har läst och accepterar ",
      "646ny1rh2k40": "sekretesspolicyn"
    },
    "successMain": {
      "647qmd42l1s0": "Beställningen mottogs framgångsrikt!",
      "647qmd42mss0": "Var uppmärksam på fraktinstruktionerna som skickas till din e-post från no-reply@danghuan.eu. Om du inte har fått dem, kontrollera din skräppostmapp eller kontakta kundtjänst på insta360@danghuan.eu",
      "647qmd42mz80": "Vårt erbjudande",
      "647qmd42yeo0": "Tips innan du skickar",
      "orderTime": "Beställningstid",
      "text1": "Fri frakt",
      "text2": "Var uppmärksam på fraktdokumentet som skickats till din e-post.",
      "text3": "Säkerhetskopiering av data",
      "text4": "För att skydda dina data, säkerhetskopiera dem och ta bort all information eller återställ enheten till fabriksinställningar.",
      "text5": "Ladda",
      "text6": "Ladda din telefon till minst 1 % innan du skickar den för att påskynda inspektionen.",
      "downloadDec": "Ladda ner integritetsförklaringen."
    },
    "tradeInProcess": {
      "649f8aefats0": "Tidsgränsen för beställningen har löpt ut",
      "649f8aefc1c0": "Återvinningen misslyckades",
      "649f8aefc9c0": "Få en ny värdering",
      "TradeIn": "Inbytesprocess",
      "logistic": "Ladda ner fraktetikett",
      "start": "Starta processen",
      "success": "Du har framgångsrikt tagit emot den nya enheten",
      "qc": "Kvalitetskontroll av den gamla enheten",
      "business": "Inspektionen av din gamla enhet kommer att vara klar inom tre arbetsdagar",
      "completed": "Slutförd",
      "successfully": "Grattis! Inbytet har slutförts framgångsrikt",
      "orderInfor": "Beställningsinformation",
      "orderID": "Återvinningsordernummer",
      "orderNum": "Nytt enhetsköps-ID",
      "createTime": "Skapelsedatum",
      "brand": "Uppskattat märke",
      "model": "modell",
      "price": "Pris för den gamla enheten",
      "bonus": "Bonus",
      "total": "Totalt pris",
      "logisticInfo": "Logistikinformation",
      "available": "Ingen logistikinformation tillgänglig",
      "logisticNum": "Logistiknummer",
      "failRey": "Vi beklagar att ditt deltagande i OnePlus återvinningsprogram inte slutfördes framgångsrikt. Om du har planer på att återvinna andra elektroniska produkter kan du klicka på knappen nedan för att få en snabb uppskattning!",
      "userRes": "Användaren har redan avvisat erbjudandet.",
      "successPrice": "Följande pris är fastställt efter professionell inspektion. Om du godkänner detta pris kan du fortsätta med inbytet. Om du avvisar det kommer enheten att skickas tillbaka till dig inom några arbetsdagar.",
      "sure": "Acceptera",
      "Reject": "Avvisa",
      "congratulation": "Grattis! Kvalitetskontrollen visade inga skillnader.",
      "finPirce": "Slutpris",
      "copySuccess": "Kopieringen lyckades",
      "copyfail": "Kopieringen misslyckades",
      "sureSuccess": "Bekräfta lyckad transaktion",
      "submitError": "Inlämningen misslyckades",
      "detectionResult": "Inspektionsresultat",
      "Collected": "Mottagen",
      "inTransit": "Under transport / Leverans",
      "understand": "Jag förstår",
      '656g0lj3sf6e': 'De kampanjbonusar erbjuds och hanteras av de anslutna varumärkena. De betalas ut separat och ingår inte i värderingen av den gamla enheten.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Vägra återvinning",
      "64a9shqq3k00": "Du bekräftar att du vägrar återvinning",
      "64a9shqq3r00": "Avbokning lyckades",
      "64a9shqq3ws0": "Avbokning misslyckades",
      "sureCancel": "Bekräfta avbokning"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Personlig information",
      "649fhwp9zbo0": "Ladda upp en tydlig bild av ditt paket",
      "649fhwpa1900": "Ladda ner fraktetiketten",
      "649fhwpa1l00": "Ladda ner fraktetiketten",
      "649fhwpa1tc0": "Leverans slutförd",
      "649fhwpa2100": "Paketbild och ärlighetsdeklaration",
      "649fhwpa2880": "Exempel på hur fraktetiketten ska placeras",
      "649fhwpa2h80": "Notering",
      "649fhwpa2qk0": "Förpackning: Slå in telefonen i bubbelplast och fyll lådan med tidningspapper för att undvika skador under transporten.",
      "649fhwpa2xs0": "Fyll eventuella tomrum med skyddande material för att undvika skador.",
      "649fhwpa3fk0": "Logistiketikett: Ta med den digitala eller utskrivna etiketten till inlämningsstället; den officiella etiketten skrivs ut där.",
      "649fhwpa3v40": "Skicka din använda telefon så snart som möjligt. Om den inte skickas inom 10 dagar kommer beställningen att annulleras.",
      "649fhwpa42s0": "Sök inlämningsställen",
      "649fhwpa4as0": "Ladda ner etiketten",
      "649fhwpa4jo0": "Ladda upp",
      "649fhwpa4ok0": "Hem",
      "649fhwpa4to0": "Inlämningen lyckades",
      "649fhwpa4yk0": "Grattis, nedladdningen lyckades!",
      "649fhwpasf3s": "Observera",
      "649fhwpaa6f3": "Skriv ut och signera ärlighetsdeklarationen, ta sedan ett foto av den tillsammans med paketet för den gamla enheten och ladda upp det."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Sociala medier",
      "646d71qugz40": "Enkel betalning",
      "646u51qugz40": "Logistik",
      "646u5dqui780": "Integritetspolicy",
      "646uddqui780": "Användarvillkor",
      "646u51qui780": "FAQ"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Om Danghuan",
      "646ntjwmn580": "Företag",
      "646nt7hwils0": "Kontakta oss",
      "646nt7hwipg0": "Köp",
      "646nt7hwis00": "Sälj"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Gratis värdering"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Ange modellen du vill sälja",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Tyvärr, modellen finns inte",
      "confirm": "Bekräfta",
      "cancle": "Avbryt",
      "dialogText": "Är du säker på att du vill radera all historik?"
    }
  },
  "PCProduct": {
    "empty": "Tyvärr, modellen finns inte"
  },
  "PCBrandTab": {
    "index": "Varumärke"
  },
  "PCCategoryTab": {
    "index": "Kategori"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Beställ online",
      "646xagqwkuw0": "Fri frakt",
      "646xagqwmao0": "Testning",
      "646xagqwmlc0": "Snabb betalning"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Hem"
    }
  },
  "router": {
    "selectModel": "Modeller",
    "selectProperty": "Enhetsproblem",
    "price": "Uppskattat pris",
    "priceOrder": "Lägg en beställning",
    "orderSuccess": "Beställningen lyckades"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Välj modell igen",
      "646ymq6ot0k0": "Påminnelse",
      "646ymq6pd100": "Innan du skickar, se till att logga ut från molnkontot",
      "646ymq6pekw0": "skärmlås / Apple-ID på den gamla enheten."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Välj enhetens skick",
      "647h1f4yr6c0": "Uppskattat pris",
      "647h1f4yso80": "Uppskattad bonus",
      "text1": "Fri frakt",
      "text2": "Vi erbjuder fri logistik- och frakttjänst",
      "text3": "Omedelbar betalning",
      "text4": "Vi genomför betalningen inom 3 arbetsdagar efter att vi mottagit din använda enhet.",
      "64tve23zt0g0": "Fri frakt och försäljningspaket",
      "64tve23zup00": "Säker dataradering",
      "64tve23zuy40": "Inte nöjd? Fri retur",
      "64tve23zv7g0": "Betalningen ordnas inom 3 arbetsdagar efter att enheten mottagits",
      "64tve23zvbg0": "Välj din leveransmetod",
      "64tve23zvf80": "Du har 10 dagar på dig att leverera din telefon.",
      "64tve23zvjc0": "Hämta en gratis fraktetikett och skicka din telefon.",
      "64tve23zvms0": "Fraktetiketten skickas till din e-post.",
      "64tve23zvqg0": "Observera:",
      "64tve23zvyo0": "På grund av fraktbegränsningar relaterade till litiumbatterier, skicka inte telefonen om du misstänker att batteriet kan vara defekt eller skadat.",
      "64tve23zwak0": "Vi kan inte returnera några tillbehör eller förpackningar som skickats med enheten.",
      "64tve23zwgs0": "Nästa steg för att sälja din telefon",
      "64tve23zwm80": "Fyll i dina kontaktuppgifter",
      "64tve23zwt00": "Förbered din telefon för leverans",
      "64tve23zwwk0": "Din enhet kommer att kontrolleras vid ankomst. Om informationen du angav är felaktig skickar vi ett nytt erbjudande. Du kan acceptera det nya erbjudandet eller få tillbaka din telefon gratis."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Ange IMEI-numret",
      "646ynp3uem40": "Slå *#06# på knappsatsen för att kontrollera telefonens IMEI."
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Visa erbjudande"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Observera: Priset på mobiltelefoner och elektronik kan minska med upp till 6 %, så vi rekommenderar att du skickar ditt paket så snart som möjligt.",
      "647hqss760c0": "Jag har läst och accepterar",
      "647hqss764w0": "sekretesspolicyn",
      "647hqss76ac0": "Användarvillkor",
      "647hqss76dg0": "Skicka",
      "647hqss76gw0": "Totalt",
      "text1": "Totalt",
      "text2": "Uppskattat pris",
      "text3": "Uppskattad bonus",
      "dialogTitle": "Observera",
      "dialogText": "Klicka på BEKRÄFTA-knappen och kontrollera din e-post för att gå vidare till nästa steg",
      "dialogBtn": "BEKRÄFTA"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Beställningsinformation",
      "647kboa06ys0": "Namn",
      "647kboa0d6v8": "Landskod",
      "647kboa078s0": "Telefon",
      "647kboa07d00": "Adress",
      "647kboa07jk0": "Land",
      "647kboa07p80": "Välj",
      "647kboa08b40": "Postnummer",
      "647kboa08h00": "Stad",
      "647kboa08zc0": "Adress",
      "647kboa09440": "Bankinformation",
      "647kboa096w0": "E-postverifiering",
      "647kboa09ao0": "E-post",
      "647kboa09dk0": "Verifieringskod",
      "647kboa09u40": "Ange",
      "647kboa09z80": "Skicka",
      "647kboa0ak00": "Fel i e-postformat",
      "647kboa0aog0": "Skickat framgångsrikt",
      "send": "Skickat",
      "submit": "Skicka",
      "error": "Fel verifieringskod",
      "64jjt96fg400": "Ange verifieringskoden",
      "64jjt96fki00": "Hämta verifieringskoden",
      "idNumber": "ID-nummer / Personnummer",
      "declaration": "Ärlighetsdeklaration",
      "download": "ladda ner",
      "647kboa0idc0": "Personligt ID",
      "647kboa0idc1": "(det officiella identitetsnumret som utfärdats av ditt land, används för identifiering i juridiska, skattemässiga eller administrativa förfaranden. Detta kan vara ditt DNI, NIE, Skattenummer, Personnummer eller CNP, eller ett annat motsvarande nationellt dokument beroende på ditt bosättningsland.)",
      "647kboa0idc2": "(det officiella identitetsnumret som utfärdats av ditt land, används för identifiering i juridiska, skattemässiga eller administrativa förfaranden. Detta kan vara ditt DNI eller NIE, Skattenummer, Personnummer eller CNP, eller ett annat motsvarande nationellt dokument, beroende på ditt bosättningsland.)",
      "idError": "Ogiltigt ID-nummer",
      "ibanTip": "Används för att ta emot betalningen för den gamla enheten.",
      "addreddPlaceholder": "Det här fältet stöder upp till 105 tecken"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Hemsida",
      "notRecyclable": "Denna typ av enhet kan inte återvinnas",
      "IKnow": "Jag förstår",
      "tips": "Tips"
    }
  },

  "blog": {
    "blogList": {
      "64wgr171lsk0": "Visningar",
      "64wgr171nq40": "Inget relevant innehåll tillgängligt.",
      "64wgr171av65": "Datum"
    },
    "blogDetail": {
      "64wgr9y5r7s0": "Visningar",
      "64wgr171wdx9": "Detaljer"
    }
  },

  "cookieNotice": {
    "title": "Cookie-meddelande",
    "description": "Vi använder cookies för att förbättra din surfupplevelse. Genom att fortsätta använda denna webbplats accepterar du vår",
    "cookiePolicy": "Cookiepolicy",
    "acceptAll": "Acceptera alla cookies",
    "acceptNecessary": "Acceptera endast nödvändiga cookies",
    "customize": {
      "title": "Välj vilka typer av cookies du vill acceptera:",
      "necessary": {
        "label": "Nödvändiga cookies",
        "description": "Dessa cookies är nödvändiga för att webbplatsen ska fungera och kan inte stängas av."
      },
      "analytics": {
        "label": "Analyscookies",
        "description": "Dessa cookies hjälper oss att förstå hur besökare använder vår webbplats."
      },
      "marketing": {
        "label": "Marknadsföringscookies",
        "description": "Dessa cookies spårar användaraktivitet på olika webbplatser för att leverera relevanta annonser."
      }
    },
    "save": "Spara inställningar",
    "cancel": "Avbryt"
  }
}